import {setEmailUser} from "../ReduxStore/userSlice";
import {getDispatch} from "../Utility/ReduxHelper";
import {getTaggedLogger} from "../Session/taggedLogging";
import {STORAGE_CACHE_KEYS} from "../Session/cachedLocalStorage";
import {isEmpty, toLower, trim} from "lodash";

const CURRENT_USER_KEY = STORAGE_CACHE_KEYS.EMAIL_USER || 'aag_user';

const logger = getTaggedLogger('userStash');

/**
 * Read from LocalStorage. This is used on startup.
 *
 * @returns {any|null}
 */
export function getStashedUser(key = CURRENT_USER_KEY) {
  let user = readCachedLocalStorage(key);
  // alert(`get stashed user from ${key}: value is ${JSON.stringify(user, null, 2)}`)
  return user;
}

/**
 * Stash user to local storage, Redux, and Google!
 * Called by the Klaviyo form handler.
 *
 * @param user
 * @return Promise that yields User object with sha256_email added
 */
export function stashUser(user = {}, {callback, ...opts} = {}) {
  const {email} = user;
  if (!email) {
    logger.warn("stashUser: email is blank")
  }

  const cleanEmail = toLower(trim(email));

  // 2025-10 Epsilon (runs tagging promo for Carlyle wants sha256'd email address.
  // Because encoding is asynch, we have to return a promise.
  return shaEncode(cleanEmail).then(value => {
    user.email_sha256 = value;

    writeUserToLocalStorage(user);

    let dispatch = getDispatch();
    dispatch(setEmailUser(user));

    // Promise delivers user { email: whatever, email_sha256: wH4t3ve4... }
    return new Promise( (resolve, reject) => {
      resolve(user);
    });
  }); // end promise
}

/***
 *
 * @example writeUserToLocalStorage({email: 'hucke@cynico.net'})
 *
 * @param user {
 *   "email": "matt@autoaccessoriesgarage.com",
 *   "source": "ju",
 *   "updatedAt": "Tue Aug 27 2024 12:18:20 GMT-0700 (Pacific Daylight Time)"
 * }
 * @param key localStorage key
 */
export function writeUserToLocalStorage(user, key = CURRENT_USER_KEY) {
  if (isEmpty(user)) {
    deleteFromCachedLocalStorage(key);
  } else {
    user.updatedAt ||= new Date().toISOString();

    writeCachedLocalStorage(key, user, {
      expiresIn: 365 * 24 * 3600
    })
  }

  return user;
}

//globalThis.writeUserToLocalStorage ||= writeUserToLocalStorage;

// tested against:
// https://emn178.github.io/online-tools/sha256.html
export async function shaEncode(input, algo = 'SHA-256') {
  // str => Uint8Array
  const bytes = new TextEncoder().encode(input);

  // ArrayBuffer
  const digest = await crypto.subtle.digest(algo, bytes);
  const arrayDigest = Array.from(new Uint8Array(digest));

  // make it hex
  return arrayDigest
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

